import { useState, useEffect, useRef } from 'react';

/**
 * Returns a debounced copy of `value`. Matches the usual filter/search pattern:
 * first paint mirrors `value`; later updates apply after `delay` ms of stability.
 * The initial mount does not schedule a timeout (no extra commit on mount).
 *
 * @param {*} value
 * @param {number} [delay=750]
 */
export function useDebouncedValue(value, delay = 750) {
    const [debounced, setDebounced] = useState(value);
    const isInitialMount = useRef(true);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
            return;
        }
        const id = setTimeout(() => setDebounced(value), delay);
        return () => clearTimeout(id);
    }, [value, delay]);

    return debounced;
}
